import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModuleWeb } from '../material/material.module';
import { WebWidgetPropertyFormsComponent } from './web-widget-property-forms.component';
import { SharedModule } from 'shared-library';



@NgModule({
  declarations: [
    WebWidgetPropertyFormsComponent
  ],
  imports: [
    CommonModule,
    MaterialModuleWeb,
    FormsModule,  
    ReactiveFormsModule,
    SharedModule,
  ],
  exports:[
    WebWidgetPropertyFormsComponent
  ]
})
export class WebWidgetPropertyFormsModule { }
